import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';
import {
  BlockType,
  DefaultBlockProps,
  DefaultMediaBlockProps,
  SwitchBlock,
} from '../switchBlock/SwitchBlock';
import style from './GridBlock.module.scss';

export type BlocksGridType = DefaultBlockProps & {
  block_type: 'grid';
  media: DefaultMediaBlockProps[];
};

export const GridBlock = ({ media }: BlocksGridType): JSX.Element | null => {
  return (
    <div className={`${style.container}  block-grid`}>
      {media.map((block, index) => {
        return <MediaBlock block_type="media" layout="responsive" media={block} key={index} />;
      })}
    </div>
  );

  return null;
};
